import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledFarmRatings = styled.div`

  .rating-summary {
    display: flex;
    flex-direction: column;
    max-width: 33%;

    @media (max-width: ${breakpoints.xs}px) {
      max-width: 100%;
    }
    div {
      justify-content: space-between;
      margin: 5px 0;
    }
    h2 {
      font-size: 20px;
      font-weight: 600;
    }
  }

  .rating-comments {
    h3 {
      margin-bottom: 20px;
      font-size: 18px;
      font-weight: 600;
    }
  }
`;

export const StyledRatingCategory = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  padding: 10px;

  .category-name {
    min-width: 150px;
    font-weight: 500;
  }

  .category-value {
    font-weight: 600;
    color: ${(props) => props.theme.ratingStarColor};
  }

  .ant-rate {
    color: ${(props) => props.theme.ratingStarColor};
  }

  .ant-rate-star-full,
  .ant-rate-star-half .ant-rate-star-first {
    color: ${(props) => props.theme.ratingStarColor};
  }
`;

export const StyledRatingComment = styled.div`
  margin-top: 15px;
  padding: 15px;
  border: 2px solid ${({ theme }) => theme.colorBorder};


  .comment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .rating-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .comment-text {
    color: ${(props) => props.theme.colorText};
    line-height: 1.6;
    margin: 0;
  }

  .ant-rate {
    color: ${(props) => props.theme.ratingStarColor};
    font-size: 16px;
  }
`;